import * as React from 'react';
import styled from '@emotion/styled';
import { style } from '../Shared/Style';
import { colors } from '../Shared/Style/colors';
import { Button } from '@ourliving/ourliving-ui';
import { ComponentProps } from 'react';

const StyledNoProject = styled.div({
    padding: '50px',
    textAlign: 'center',
    minHeight: '436px',
    display: 'grid',
    alignContent: 'center',
});

const NoProjectTitle = styled.span({
    marginBottom: '2rem',
    fontSize: style.fontSize.gamma,
});

const NoProjectDescription = styled.span({
    marginBottom: '1rem',
    fontSize: style.fontSize.epsilon,
    color: colors.secondary,
});

const EmptyState = (props: ComponentProps<'div'>) => {
    return <StyledNoProject {...props} />;
};

type Props = {
    children?: React.ReactNode;
};

const Title: React.FC<Props> = ({ children, ...rest }) => {
    return <NoProjectTitle {...rest}>{children}</NoProjectTitle>;
};
const Description: React.FC<Props> = ({ children, ...rest }) => {
    return <NoProjectDescription {...rest}>{children}</NoProjectDescription>;
};
const EmptyStateButton: React.FC<React.ComponentProps<typeof Button>> = ({ children, ...rest }) => {
    return <Button {...rest}>{children}</Button>;
};

EmptyState.Title = Title;
EmptyState.Description = Description;
EmptyState.Button = EmptyStateButton;

export default EmptyState;
